/**
 * @desc 批量推送EBS
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierEbsRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/pushEbs`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
